import { createStore } from 'vuex';
import {store as auth, AuthStore, State as AuthState} from './modules/auth'
import {store as common, CommonStore, State as CommonState} from './modules/common'
import {store as request, RequestStore, State as RequestState} from './modules/request'


export type RootState = {
  auth: AuthState,
  common: CommonState,
  request: RequestState
};

export type Store = AuthStore<Pick<RootState, 'auth'>> & CommonStore<Pick<RootState, 'common'>> & 
                    RequestStore<Pick<RootState, 'request'>>;

// Plug in logger when in development environment
// const debug = process.env.NODE_ENV !== 'production';
// const plugins = debug ? [createLogger({})] : [];

export const store = createStore({
  // plugins,
  modules: {
    auth,
    common,
    request
  },
});

export function useStore(): Store {
  return store as Store;
}

export default store;